/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import React from "react";
import { Alert, Box, Grid, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Select, MenuItem, FormControl,Typography, Skeleton, useTheme, alpha, TextField,} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate, useParams } from "react-router-dom";
import { Palette, PaletteColor } from '@mui/material/styles/createPalette';
import { useDebounce } from "../../../shared/hooks";
import { LocalizacaoService } from "../../../shared/services/api/estoque/localizacao/LocalizacaoService";
import * as yup from "yup";
import { VForm, useVForm, IVFormErrors } from "../../../shared/forms";
import { LayoutBaseDePaginaNfe } from "../../../shared/layouts";
import { FerramentasDeDetalheEntradaSaida } from "../../../shared/components/ferramentas-de-detalhe/FerramentasDeDetalheEntradaSaida";
import { SolicitacaoService } from "../../../shared/services/api/estoque/solicitacao/SolicitacaoService";
import { CheckCircle, Error as ErrorIcon, HourglassEmpty, Info, Inventory2 } from "@mui/icons-material";
import PDFSaida from "./Impressaosaida";

interface IFormData {
  impresso?: boolean;
  datavisualizado?: Date | string;
  obs?: string;
  status?: number;
}
interface IItenssolicitacao {
  iditem: string;
  idsolicitacao: string;
  qtd: number;
  qtdenviado: number;
  descricao: string;
  datalan: Date;
  un: string;
  referencia: string;
  urgente: boolean;
  status: number;
}
interface ISolicitacaoUpdate {
  impresso?: boolean;
  datavisualizado?: Date;
  status?: number;
  item: IItenssolicitacao[];
}
const formValidationSchema: yup.ObjectSchema<
  Omit<IFormData, 'idsolicitacao' | 'item' | 'obs'>
> = yup.object().shape({
  datavisualizado: yup.date().optional(),
  impresso: yup.boolean().optional(),
  status: yup.number().optional(),
});
const validateItems = (data: any): IItenssolicitacao[] => {
  if (!Array.isArray(data)) return [];
  return data.map(item => ({
    iditem: item.iditem,
    idsolicitacao: item.idsolicitacao,
    qtd: Number(item.qtd) || 0,
    qtdenviado: Number(item.qtdenviado) || 0,
    descricao: item.descricao,
    datalan: item.datalan ? new Date(item.datalan) : new Date(),
    un: item.un || 'un',
    referencia: item.referencia || '',
    urgente: item.urgente || false,
    status: item.status || 0
  }));
};
type ValidPaletteColor = 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
interface ISolicitacaoStatus {
  value: number;
  label: string;
  icon: JSX.Element;
  color: string;
}
interface IItemStatus {
  value: number;
  label: string;
  icon: JSX.Element;
  color: string;
}
interface StatusChipProps {
  status: number;
  onChange?: (newStatus: number) => void;
  editable?: boolean;
  statusOptions: ISolicitacaoStatus[] | IItemStatus[];
}
const StatusChip: React.FC<StatusChipProps> = ({
  status,
  onChange,
  editable = true,
  statusOptions
}) => {
  const theme = useTheme();
  const getPaletteColor = (palette: Palette, color: string | ValidPaletteColor): PaletteColor | string => {
    if (color.startsWith('#') || color.startsWith('rgb')) return color;
    return palette[color as ValidPaletteColor] as PaletteColor;
  };
  const selectedStatus = statusOptions.find(opt => opt.value === status) || statusOptions[0];
  const paletteColor = getPaletteColor(theme.palette, selectedStatus.color);
  const backgroundColor =
    typeof paletteColor === 'string'
      ? paletteColor + '20'
      : alpha(paletteColor.light, 0.1);

  return (
    <FormControl fullWidth size="small">
      <Select
        value={status}
        onChange={(e) => editable && onChange && onChange(Number(e.target.value))}
        disabled={!editable}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
          '& .MuiSelect-select': {
            py: 1.5,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            borderRadius: '16px',
            backgroundColor,
            '&:hover': {
              backgroundColor:
                typeof paletteColor === 'string'
                  ? paletteColor + '30'
                  : alpha(paletteColor.light, 0.2),
            },
          },
        }}
        renderValue={() => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {React.cloneElement(selectedStatus.icon, { fontSize: 'small' })}
            <Typography variant="body2">{selectedStatus.label}</Typography>
          </Box>
        )}
      >
        {statusOptions.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{ py: 1.5, borderRadius: '8px', margin: '4px' }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {React.cloneElement(option.icon, { fontSize: 'small' })}
              <Typography variant="body2">{option.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export const DetalheSolicitacao: React.FC = () => {
  const { id = "novo" } = useParams<"id">();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState<IItenssolicitacao[]>([]);
  const [solicitante, setSolicitante] = useState("");
  const [idlocalizacao, setIdLocalizacao] = useState("");
  const [localizacao, setLocalizacao] = useState("");
  const [obs, setobs] = useState("");
  const [status, setstatus] = useState(0);
  const [dataenvio, setDataEnvio] = useState<string | Date>("");
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [tms, setTms] = useState<"warning" | "error" | "info" | "success">("warning");
  const theme = useTheme();
  const { debounce } = useDebounce();
  const isFinalizado = status === 5;
  const resetStates = () => {
    setSolicitante("");
    setIdLocalizacao("");
    setLocalizacao("");
    setRows([]);
    formRef.current?.reset();
  };
  const formatDateTime = (dateString: string | Date) => {
    if (!dateString) return '';
    const date = dateString instanceof Date ? dateString : new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };
  const handleCloseMsg = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") return;
    setOpenmsg(false);
  };
  const solicitacaoStatusOptions: ISolicitacaoStatus[] = [
    { value: 2, label: "Recebido", icon: <CheckCircle sx={{ color: '#2ecc71' }} />, color: '#2ecc71' },
    { value: 3, label: "Visualizado", icon: <VisibilityIcon sx={{ color: '#f1c40f' }} />, color: '#f1c40f' },
    { value: 4, label: "Separando", icon: <HourglassEmpty sx={{ color: '#3498db' }} />, color: '#3498db' },
    { value: 5, label: "Finalizado", icon: <CheckCircle sx={{ color: '#1e8449' }} />, color: '#1e8449' },
  ];
  const itemStatusOptions: IItemStatus[] = [
    { value: 1, label: "A Separar", icon: <VisibilityIcon sx={{ color: '#f1c40f' }} />, color: '#f1c40f' },
    { value: 2, label: "Separado", icon: <HourglassEmpty color="primary" />, color: "primary" },
    { value: 3, label: "Não Encontrado", icon: <ErrorIcon color="error" />, color: "error" }
  ];
  const [initialLoad, setInitialLoad] = useState(true);
  useEffect(() => {
    const loadData = async () => {
      if (id !== "novo") {
        setIsLoading(true);
        try {
          const result = await SolicitacaoService.getById(id);
          if (result instanceof Error) throw result;
          setSolicitante(result.solicitante || '');
          setstatus(result.status || 0);
          setIdLocalizacao(result.idlocalizacao || '');
          setDataEnvio(result.dataenvio);
          setobs(result.obs || "");
          setRows(validateItems(result.item || []));
          if (result.status === 2) {
            await SolicitacaoService.updateById(
              result.idsolicitacao,
              {
                status: 3,
                item: []
              },
              []
            );
          }
          if (result.idlocalizacao) {
            const locResult = await LocalizacaoService.getById(result.idlocalizacao);
            if (!(locResult instanceof Error)) {
              setLocalizacao(locResult.descricao);
            }
          }
        } catch (error) {
          setTms("error");
          setMsg(String(error));
          setOpenmsg(true);
        } finally {
          setIsLoading(false);
          setInitialLoad(false);
        }
      }
    };
    if (initialLoad || !formRef.current?.getData()) {
      formRef.current?.reset();
      loadData();
    }
  }, [id, initialLoad, status, rows.map(row => row.iditem).join(',')]);
  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      if (!idlocalizacao) {
        setIsLoading(false);
        return;
      }
      LocalizacaoService.getById(idlocalizacao).then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms("error");
          setMsg(result.message);
          setOpenmsg(true);
          return;
        }
        setLocalizacao(result.descricao);
      });
    });
  }, [id, idlocalizacao, debounce]);

  const handleSave = (dados: IFormData) => {
    if (isFinalizado) {
      setTms("info");
      setMsg("Solicitação já finalizada. Não é possível salvar alterações.");
      setOpenmsg(true);
      return;
    }
    if (rows.length === 0) {
      setTms("warning");
      setMsg("A solicitação deve conter no mínimo um ítem.");
      setOpenmsg(true);
      return;
    }
    formValidationSchema.validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        const dadosParaAtualizar: ISolicitacaoUpdate = {
          datavisualizado: dadosValidados.datavisualizado ? new Date(dadosValidados.datavisualizado) : undefined,
          impresso: dadosValidados.impresso,
          status: dadosValidados.status,
          item: rows
        };
        SolicitacaoService.updateById(id, dadosParaAtualizar, rows)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms("error");
              setMsg(result.message);
            } else {
              setTms("success");
              setMsg("Atualização concluída com sucesso!");
              if (isSaveAndClose()) navigate(`/solicitacao/${idlocalizacao}`);
            }
            setOpenmsg(true);
          });
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };
  const handleUpdateQtdenviado = async (iditem: string, qtd: number, newQtdenviado: number) => {
    if (isFinalizado) {
      setTms("info");
      setMsg("Solicitação finalizada. Não é possível alterar quantidades.");
      setOpenmsg(true);
      return;
    }
    const itemAtual = rows.find((item) => item.iditem === iditem);
    if (!itemAtual) return;
    const qtAnterior = itemAtual.qtdenviado;
    const statusAnterior = itemAtual.status;
    try {
      const qtdNumber = Number(qtd);
      if (isNaN(qtdNumber)) {
        setTms("error");
        setMsg("Erro interno: quantidade inválida.");
        setOpenmsg(true);
        return;
      }
      const novoStatusItem = newQtdenviado === 0 ? 3 : 2;
      const result = await SolicitacaoService.updateItemById(
        iditem,
        qtdNumber,
        newQtdenviado,
        novoStatusItem
      );
      if (result instanceof Error) throw result;
      setRows((prev) =>
        prev.map((item) =>
          item.iditem === iditem
            ? { ...item, qtdenviado: newQtdenviado, status: novoStatusItem }
            : item
        )
      );
      if (newQtdenviado > 0) {
        const updateSolicitacaoResult = await SolicitacaoService.updateById(
          id,
          {
            status: 4,
            item: []
          },
          []
        );
        if (updateSolicitacaoResult instanceof Error) throw updateSolicitacaoResult;
        setstatus(4);
        setTms("success");
        setMsg("Quantidade enviada atualizada. Solicitação marcada como 'Separando'.");
      } else {
        setTms("info");
        setMsg("Quantidade zerada. Item marcado como 'Não Encontrado'.");
      }
      setOpenmsg(true);
    } catch (error: any) {
      setRows((prev) =>
        prev.map((item) =>
          item.iditem === iditem
            ? { ...item, qtdenviado: qtAnterior, status: statusAnterior }
            : item
        )
      );
      setTms("error");
      setMsg(error.message || "Falha ao atualizar quantidade enviada. Alterações revertidas.");
      setOpenmsg(true);
    }
  };
  const handleImpressao = async (idsolicitacao: string) => {
    if (isFinalizado) {
      setTms("info");
      setMsg("Solicitação finalizada. Impressão desabilitada.");
      setOpenmsg(true);
      return;
    }
    try {
      const result = await SolicitacaoService.getById(idsolicitacao);
      if (result instanceof Error) {
        setTms("error");
        setMsg(result.message);
        setOpenmsg(true);
        return;
      }
      if (!result.impresso) {
        const updateResponse = await SolicitacaoService.updateById(
          result.idsolicitacao,
          {
            impresso: true,
            status: result.status,
            item: []
          },
          []
        );
        if (updateResponse instanceof Error) {
          setTms("error");
          setMsg(updateResponse.message);
          setOpenmsg(true);
          return;
        }
      }
      PDFSaida(result, localizacao);
    } catch (error: any) {
      setTms("error");
      setMsg(error.message || "Erro inesperado");
      setOpenmsg(true);
    }
  };
  const handleFinalizar = async () => {
    if (isFinalizado) {
      setTms("info");
      setMsg("Solicitação já está finalizada.");
      setOpenmsg(true);
      return;
    }
    setIsLoading(true);
    const hasOpenItems = rows.some(item => item.status === 1);
    if (hasOpenItems) {
      setIsLoading(false);
      setTms("error");
      setMsg("Não é possível finalizar a solicitação pois existem itens em aberto");
      setOpenmsg(true);
      return;
    }
    try {
      const updateSolicitacaoResult = await SolicitacaoService.updateById(
        id,
        {
          status: 5,
          item: []
        },
        []
      );
      if (updateSolicitacaoResult instanceof Error) {
        throw updateSolicitacaoResult;
      }
      setTms("success");
      setMsg("Solicitação finalizada com sucesso!");
      setOpenmsg(true);
      setstatus(5);

      setTimeout(() => {
        navigate(`/solicitacao/${idlocalizacao}`);
      }, 2000);
    } catch (error: any) {
      setTms("error");
      setMsg(error.message || "Falha ao finalizar a solicitação");
      setOpenmsg(true);
    } finally {
      setIsLoading(false);
    }
  };
  const gerarCodigoSimples = (uuid: string): number => {
  const last = uuid.split('-').pop()!;
  return parseInt(last.substring(0, 4), 16);
};
  return (
    <LayoutBaseDePaginaNfe
      barraDeFerramentas={  
        <FerramentasDeDetalheEntradaSaida     
          textoBotaoNovo={`${localizacao} - ${gerarCodigoSimples(id)}`}
          solicitante={solicitante}
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoSalvarCarregando={isLoading} 
          mostrarBotaoSalvarEFecharCarregando={isLoading} 
          mostrarBotaoNovo={false}
          mostrarBotaoApagar={false}
          mostrarBotaoFinalizar={true}
          aoClicarEmFinalizar={isFinalizado ? () => {
            setTms("info");
            setMsg("Solicitação finalizada. Botão de finalizar está desabilitado.");
            setOpenmsg(true);
          } : () => handleFinalizar()}
          mostrarBotaoSalvar={false}
          mostrarBotaoImpressao={true}
          aoClicarEmSalvar={save}
          aoClicarEmImpressao={isFinalizado ? () => {
            setTms("info");
            setMsg("Solicitação finalizada. Impressão está desabilitada.");
            setOpenmsg(true);
          } : () => handleImpressao(id)}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate(`/solicitacao/${idlocalizacao}`)}
          mostrarBotaoVoltarCarregando={isLoading}
          mostrarBotaoNovoCarregando={isLoading}
          sx={{
            mt: 0,
            mb: 0,
            p: 2,
            backgroundColor: 'background.paper',
            borderRadius: 3,  
            boxShadow: theme.shadows[1],
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
          }}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave}>
        <Snackbar
          open={openmsg}
          autoHideDuration={6000}
          onClose={handleCloseMsg}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            elevation={6}
            variant="filled"
            onClose={handleCloseMsg}
            severity={tms}
            icon={false}
            sx={{
              width: '100%',
              borderRadius: '12px',
              alignItems: 'center',
              '& .MuiAlert-message': {
                display: 'flex',
                alignItems: 'center',
                gap: 2
              }
            }}
          >
            {tms === 'success' && <CheckCircle fontSize="large" />}
            {tms === 'error' && <ErrorIcon fontSize="large" />}
            {tms === 'warning' && <ErrorIcon fontSize="large" />}
            {tms === 'info' && <Info fontSize="large" />}
            <Typography variant="body1" fontWeight={500}>{msg}</Typography>
          </Alert>
        </Snackbar>
        <Box
          component={Paper}
          sx={{
            p: 4,
            mb: 3,
            borderRadius: 3,
            boxShadow: theme.shadows[1],
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            backgroundColor: 'background.paper'
          }}
        >
          <Grid container spacing={3}>
            {isLoading ? (
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  <Skeleton variant="rounded" height={72} sx={{ borderRadius: 2 }} />
                  <Skeleton variant="rounded" height={72} sx={{ borderRadius: 2 }} />
                  <Skeleton variant="rounded" height={400} sx={{ borderRadius: 2 }} />
                </Box>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} md={8}>
                  <TextField
                    fullWidth
                    size="small"
                    value={solicitante}
                    label="Solicitante"
                    disabled={true} 
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: alpha(theme.palette.background.default, 0.5),
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    name='dataenv'
                    value={dataenvio ? formatDateTime(dataenvio) : ''}
                    label="Data de Envio"
                    disabled={true}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: alpha(theme.palette.background.default, 0.5),
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={2}>
                  <StatusChip
                    status={status}
                    onChange={() => { }}
                    editable={false}
                    statusOptions={solicitacaoStatusOptions}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    name="obs"
                    value={obs}
                    label="Observações"
                    multiline
                    rows={3}
                    variant="outlined"
                    disabled={true}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: alpha(theme.palette.background.default, 0.5),
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mb: 2
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold">
                      Itens da Solicitação
                    </Typography>
                    <Chip
                      label={`${rows.length} itens`}
                      size="small"
                      sx={{
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                        color: theme.palette.primary.main,
                        fontWeight: 500,
                        borderRadius: '6px'
                      }}
                    />
                  </Box>
                  <Paper
                    elevation={0}
                    sx={{
                      border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                      borderRadius: 3,
                      overflow: 'hidden',
                      backgroundColor: 'background.paper'
                    }}
                  >
                    <TableContainer
                      sx={{
                        maxHeight: 500,
                        '&::-webkit-scrollbar': {
                          width: '6px',
                          height: '6px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: alpha(theme.palette.primary.main, 0.3),
                          borderRadius: '4px'
                        }
                      }}
                    >
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow
                            sx={{
                              '& th': {
                                backgroundColor: alpha(theme.palette.background.default, 0.8),
                                backdropFilter: 'blur(8px)',
                                fontWeight: 'bold',
                                color: 'text.primary',
                                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                                '&:first-of-type': { borderRadius: '12px 0 0 0' },
                                '&:last-of-type': { borderRadius: '0 12px 0 0' },
                              },
                            }}
                          >
                            <TableCell align="center" sx={{ width: 80 }}>Qtd</TableCell>
                            <TableCell>Descrição</TableCell>
                            <TableCell sx={{ width: 80 }}>UN</TableCell>
                            <TableCell sx={{ width: 120 }}>Prioridade</TableCell>
                            <TableCell sx={{ width: 120 }} align="center">Qtd. Enviada</TableCell>
                            <TableCell sx={{ width: 200 }} align="center">Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.length > 0 ? (
                            rows.map((row) => (
                              <TableRow
                                key={row.iditem}
                                hover
                                sx={{
                                  '&:last-child td': {
                                    borderBottom: 0,
                                    '&:first-of-type': { borderRadius: '0 0 0 12px' },
                                    '&:last-of-type': { borderRadius: '0 0 12px 0' },
                                  },
                                  '&:hover': {
                                    backgroundColor: alpha(theme.palette.primary.light, 0.03),
                                  },
                                }}
                              >
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                                  {parseFloat(String(row.qtd).replace(',', '.')).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </TableCell>
                                <TableCell>
                                  <Typography>{row.descricao}</Typography>
                                  {row.referencia && (
                                    <Typography variant="caption" color="text.secondary">
                                      Ref: {row.referencia}
                                    </Typography>
                                  )}
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={row.un}
                                    size="small"
                                    sx={{
                                      backgroundColor: alpha(theme.palette.secondary.light, 0.1),
                                      color: 'text.secondary',
                                      borderRadius: '6px',
                                      fontWeight: 500,
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={row.urgente ? 'URGENTE' : 'Normal'}
                                    color={row.urgente ? 'error' : 'default'}
                                    size="small"
                                    icon={row.urgente ? <ErrorIcon fontSize="small" /> : undefined}
                                    sx={{
                                      fontWeight: 500,
                                      height: 26,
                                      borderRadius: '6px',
                                      '& .MuiChip-icon': { marginLeft: '6px' },
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    type="text"
                                    size="small"
                                    value={row.qtdenviado ?? ''}
                                    disabled={isFinalizado}
                                    onChange={(e) => {
                                      if (isFinalizado) return;
                                      const input = e.target.value.replace(',', '.');
                                      if (input === '') {
                                        setRows((prev) =>
                                          prev.map((r) =>
                                            r.iditem === row.iditem ? { ...r, qtdenviado: 0 } : r
                                          )
                                        );
                                        return;
                                      }
                                      const value = Number(input);
                                      if (isNaN(value)) return;
                                      if (value < 0) {
                                        setTms('error');
                                        setMsg('A quantidade enviada deve ser maior que 0.');
                                        setOpenmsg(true);
                                        return;
                                      }
                                      if (value > row.qtd) {
                                        setTms('error');
                                        setMsg('A quantidade enviada não pode ser maior que a quantidade solicitada.');
                                        setOpenmsg(true);
                                        return;
                                      }
                                      setRows((prev) =>
                                        prev.map((r) =>
                                          r.iditem === row.iditem ? { ...r, qtdenviado: value } : r
                                        )
                                      );
                                      handleUpdateQtdenviado(row.iditem, row.qtd, value);
                                    }}
                                    inputProps={{
                                      inputMode: 'decimal',
                                      style: { textAlign: 'center' },
                                    }}
                                    sx={{
                                      width: 100,
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        backgroundColor: alpha(theme.palette.background.default, 0.6),
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <StatusChip
                                    status={row.status}
                                    editable={!isLoading && !isFinalizado}
                                    onChange={async (newStatus) => {
                                      if (isFinalizado) {
                                        setTms("info");
                                        setMsg("Solicitação finalizada. Não é possível alterar o status dos itens.");
                                        setOpenmsg(true);
                                        return;
                                      }
                                      if (
                                        (row.status === 2 && newStatus === 1) ||
                                        (row.status === 3 && newStatus === 1)
                                      ) {
                                        setTms("error");
                                        setMsg("Não é permitido retornar para 'A Separar' após o item ter sido processado.");
                                        setOpenmsg(true);
                                        return;
                                      }
                                      let novoQtdeEnviado = row.qtdenviado;
                                      if (newStatus === 2) novoQtdeEnviado = row.qtd;
                                      if (newStatus === 3) novoQtdeEnviado = 0;
                                      const result = await SolicitacaoService.updateItemById(
                                        row.iditem,
                                        row.qtd,
                                        novoQtdeEnviado,
                                        newStatus
                                      );
                                      if (result instanceof Error) {
                                        setTms("error");
                                        setMsg(result.message);
                                        setOpenmsg(true);
                                        return;
                                      }
                                      const novosItens = rows.map(r =>
                                        r.iditem === row.iditem
                                          ? { ...r, status: newStatus, qtdenviado: novoQtdeEnviado }
                                          : r
                                      );
                                      setRows(novosItens);
                                      if (newStatus === 2 || newStatus === 3) {
                                        await SolicitacaoService.updateById(
                                          id,
                                          {
                                            status: 4,
                                            item: []
                                          },
                                          []
                                        );
                                        setstatus(4);
                                      }
                                      setTms("success");
                                      setMsg(
                                        newStatus === 2
                                          ? "Item marcado como 'Separado'. Solicitação marcada como 'Separando'."
                                          : newStatus === 3
                                            ? "Item marcado como 'Não Encontrado'. Solicitação marcada como 'Separando'."
                                            : "Status atualizado."
                                      );
                                      setOpenmsg(true);
                                    }}
                                    statusOptions={itemStatusOptions}
                                  />
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2,
                                    color: 'text.disabled',
                                  }}
                                >
                                  <Inventory2 sx={{ fontSize: 48 }} />
                                  <Box textAlign="center">
                                    <Typography variant="h6" fontWeight="medium">
                                      Nenhum item encontrado
                                    </Typography>
                                    <Typography variant="body2">
                                      Adicione itens para visualizar a lista
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </VForm>
    </LayoutBaseDePaginaNfe>
  );
};
